function retrieveDisplayPricesToCrew(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/display-prices-to-crew`);
}

function updateDisplayPricesToCrew(companyId, displayPricesToCrew) {
    return window.tenantAxios.patch(`/company/${companyId}/display-prices-to-crew`, displayPricesToCrew);
}

export default {
    retrieveDisplayPricesToCrew,
    updateDisplayPricesToCrew,
};
